import classnames from 'classnames';
import React from 'react';
import styles from './emoji.module.scss';

export const Emoji = ({ value, onClick, size = '20px', disabled = false }) => {
  return (
    <div
      style={{ width: size, height: size }}
      onClick={(e) => {
        e.stopPropagation();
        onClick && !disabled && onClick(value);
      }}
      className={classnames({
        [styles.hoverAnim]: !disabled,
        [styles.faded]: disabled,
      })}
    >
      <svg viewBox="-50 -50 100 100" preserveAspectRatio="xMidYMid meet">
        <text
          fontSize="100"
          textAnchor="middle"
          dominantBaseline="middle"
          dy="10"
        >
          {value}
        </text>
      </svg>
    </div>
  );
};
